function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "11",
  height: "20",
  viewBox: "0 0 11 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.975 9.992c.053.385-.067.79-.362 1.088l-8.46 8.531a1.274 1.274 0 01-1.806-.002l.041.042a1.294 1.294 0 01-.001-1.82L8.15 10 .387 2.17A1.3 1.3 0 01.388.35l-.04.042A1.268 1.268 0 012.152.39l8.46 8.531c.29.292.409.69.362 1.07z",
  fill: "currentColor",
  fillRule: "evenodd"
})));